import styled from "styled-components";

export const DivWrapper = styled.div`
  cursor: pointer;
  /* Touch screens keep :hover on the tapped spot, so the answer at the same
     place on the next question looked preselected */
  @media (hover: hover) {
    &:hover {
      background-color: #efefef;
    }
  }
`;
